import { DisasterStatus } from "./disaster-status";

export class ClinicStatus {

  institutionId: number;

  institutionName: string;

  institutionKana: string;

  syllabaryId: number;

  syllabaryDisplayName: string;

  consultation: DisasterStatus;

  electricity: DisasterStatus;

  waterSupply: DisasterStatus;

  phone: DisasterStatus;

  comment: string;

  directorName: string;

  medicalCoursesName: string;

  address: string;

  tel: string;

  fax: string;

  updateTime: Date;

  update(source: ClinicStatus) {
    this.institutionId = source.institutionId;
    this.institutionName = source.institutionName;
    this.institutionKana = source.institutionKana;
    this.syllabaryId = source.syllabaryId;
    this.syllabaryDisplayName = source.syllabaryDisplayName;
    this.consultation = source.consultation;
    this.electricity = source.electricity;
    this.waterSupply = source.waterSupply;
    this.phone = source.phone;
    this.comment = source.comment;
    this.directorName = source.directorName;
    this.medicalCoursesName = source.medicalCoursesName;
    this.address = source.address;
    this.tel = source.tel;
    this.fax = source.fax;
    this.updateTime = source.updateTime;
  }
}
